import { EventEmitter } from "@angular/core";
import { ButtonsActionsTableComponent } from "@app/shared";

export class InactivateUserConfigService{
  // Se emite cada vez que se realiza una accion con los botones de la tabla
  accion: EventEmitter<any> = new EventEmitter();
  // Se emite cada vez que se realiza una accion con los botones de la tabla de la modal
  accionModal: EventEmitter<any> = new EventEmitter();
  // Contiene la configuracion de la tabla
  settings = {};
  // Contiene la configuracion de la modal
  settingsModal = {};

  constructor(){
    const self = this;
    this.settings = {
      mode: 'external',
      actions: false,
      noDataMessage: 'No hay resultados',
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        motivo: {
          editable: false,
          addable: false,
          title: 'Motivo',
          class: 'prueba',
          filter: {
            inputClass: 'form-control',
          },
        },
        fecha_inicial: {
          editable: false,
          addable: false,
          title: 'Fecha inicial',
          class: 'prueba',
        },
        fecha_final: {
          editable: false,
          addable: false,
          title: 'Fecha final',
          class: 'prueba',
        },
        button: {
          title: 'Acciones',
          filter: false,
          sort: false,
          type: 'custom',
          renderComponent: ButtonsActionsTableComponent,
          onComponentInitFunction(instance: any) {
            instance.hidensView = true;
            instance.viewDetail = true;
            instance.hidenUpdated = true;

            // instance.disableUpdated = true
            instance.save.subscribe((data: any) => {
              // Controla el evento click del boton
              self.accion.emit(data);
            });
          }
        },
      },
    };
  }
}


// WEBPACK FOOTER //
// ./src/app/administration/system-users-inactivation/inactivate-users/shared/inactivate-user-config.service.ts